import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, Mail, Shield } from 'lucide-react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSendCode = async () => {
    setLoading(true);
    try {
      const { data } = await api.post('/auth/forgot-password');
      toast.success(data.message || 'تم إرسال كود الاسترجاع');
      navigate('/admin/reset-password', { state: { codeSent: true } });
    } catch (error) {
      toast.error(error.response?.data?.message || 'تعذر إرسال كود الاسترجاع');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-orvix-dark relative overflow-hidden">
      <div className="absolute top-0 right-0 w-96 h-96 bg-orvix-primary/10 rounded-full blur-3xl" />
      <div className="glass relative z-10 w-full max-w-md p-8 mx-4">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-br from-orvix-primary to-orvix-green rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">استرجاع كلمة المرور</h1>
          <p className="text-gray-400 text-sm">سيتم إرسال كود مكوّن من 6 أرقام إلى البريد المحفوظ في إعدادات الموقع.</p>
        </div>

        <div className="space-y-5">
          <div className="p-4 rounded-xl bg-white/5 border border-white/10 text-gray-300 text-sm flex gap-3 items-start">
            <Mail size={20} className="text-orvix-green mt-0.5" />
            <span>اضغط إرسال الكود ثم افتح البريد المسجل في الإعدادات. صلاحية الكود 10 دقائق.</span>
          </div>
          <button type="button" onClick={handleSendCode} disabled={loading} className="btn-primary w-full disabled:opacity-50">
            {loading ? 'جاري الإرسال...' : 'إرسال كود الاسترجاع'}
          </button>
          <Link to="/admin/login" className="text-sm text-gray-400 hover:text-white flex items-center justify-center gap-2">
            <ArrowRight size={16} /> العودة لتسجيل الدخول
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
